import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cookie_consent');
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)',
      zIndex: 999, width: 'calc(100% - 40px)', maxWidth: '640px',
      background: 'rgba(26,32,44,0.97)', backdropFilter: 'blur(12px)',
      borderRadius: '16px', padding: '18px 20px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      border: '1px solid rgba(255,255,255,0.1)',
      animation: 'fadeUp .3s ease',
    }}>
      <div style={{ display: 'flex', gap: '16px', alignItems: 'center', flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: '200px' }}>
          <p style={{ fontSize: '13px', color: '#E2E8F0', lineHeight: 1.6, margin: 0 }}>
            🍪 Agora utilise un token d'authentification (localStorage) strictement nécessaire au fonctionnement du service. Aucun cookie publicitaire n'est utilisé.{' '}
            <Link to="/legal/confidentialite" style={{ color: '#63B3ED', fontWeight: 600 }}>En savoir plus</Link>
          </p>
        </div>
        <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
          <button onClick={decline} style={{ background: 'transparent', color: '#A0AEC0', border: '1px solid rgba(255,255,255,0.2)', padding: '8px 16px', borderRadius: '20px', fontSize: '13px', cursor: 'pointer', fontWeight: 500 }}>
            Refuser
          </button>
          <button onClick={accept} style={{ background: '#2B6CB0', color: '#fff', border: 'none', padding: '8px 20px', borderRadius: '20px', fontSize: '13px', fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 12px rgba(43,108,176,0.4)' }}>
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
}
